import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appReducersActions } from "../store/reducers/app";
import { useCheckCurrentPageValidate, useFormateMsg, useSubmit } from "../hooks";
import { scroller } from "react-scroll";
import { Form } from "antd";
import { isEmpty } from "../utils/index";

const useScroll = () => {
  const { currentPage } = useSelector((state) => state.app);
  const handler = (questionList) => {
    let status = true;
    let scrollPosition = questionList.find((o) => {
      return o.pageNum?.toString() == currentPage.toString() && o.errorMsg;
    })?.position;
    if (!isEmpty(scrollPosition)) {
      scroller.scrollTo(`question-${scrollPosition}`, {containerId:"root", duration: 500, smooth: true });
      status = false;
    }
    return status;
  };
  const scrollTop = () => {
    window.scrollTo(0, 0);
  };
  return { handler, scrollTop };
};

const findJumpPage = (type, toPage, questionList) => {
  let status = true;
  let totalPage = questionList[questionList.length - 1].pageNum;
  let prevPageIndex;
  let nextPageIndex;
  let forStatrtIndex = 0;
  let forEndIndex = questionList.length;
  while (status === true) {
    if (toPage <= 0 || totalPage === toPage) {
      break;
    }
    let tempArr = [];
    if (prevPageIndex) forStatrtIndex = prevPageIndex;
    if (nextPageIndex) forEndIndex = nextPageIndex;
    prevPageIndex = undefined;
    nextPageIndex = undefined;
    for (let i = forStatrtIndex; i < forEndIndex; i++) {
      let item = questionList[i];
      if (type == "next" && !prevPageIndex && item.pageNum === toPage + 1) {
        prevPageIndex = i;
      }
      if (type == "prev" && !nextPageIndex && item.pageNum === toPage) {
        nextPageIndex = i;
      }
      if (item.pageNum == toPage && item.type != "4") {
        let isHide = item.jumpShow === false || item.relateShow === false;
        if (!isHide) tempArr.push(item);
      }
    }
    if (tempArr.length != 0) {
      status = false;
    } else {
      toPage = type == "prev" ? toPage - 1 : toPage + 1;
    }
  }
  return toPage;
};

const Footer = ({ form }) => {
  const dispatch = useDispatch();
  const { formatMsg } = useFormateMsg();
  const { currentPage, totalPage, posting, previewType, previewCheck, jumpType } = useSelector((state) => state.app);
  const { handler: checkCurrentPage } = useCheckCurrentPageValidate(form);
  const { handler: scrollHandler, scrollTop } = useScroll();
  const { handler: submit } = useSubmit(form);
  const pageObj = useMemo(() => {
    const submit = currentPage === totalPage;
    const prev = currentPage > 1;
    const next = currentPage < totalPage;
    return { submit, prev, next };
  }, [currentPage, totalPage]);
  const handleNext = () => {
    const { suveryInfo } = form.getFieldsValue();
    let { status, questionList } = checkCurrentPage();
    if (status) {
      let page;
      if (jumpType !== "0") {
        page = totalPage;
      } else if (previewCheck.toString() === "true") {
        page = currentPage + 1;
      } else {
        page = findJumpPage("next", currentPage + 1, questionList);
      }
      scrollTop();
      dispatch(appReducersActions.setCurrentPage(page));
    } else {
      scrollHandler(questionList);
      form.setFieldsValue({ suveryInfo: { ...suveryInfo, questionList } });
    }
  };
  const handlePrev = (type) => {
    scrollTop();
    const {
      suveryInfo: { questionList },
    } = form.getFieldsValue();
    let page = findJumpPage("prev", currentPage - 1, questionList);
    page = page < 1 ? 1 : page;
    dispatch(appReducersActions.setCurrentPage(page));
  };
  const handleSubmit = () => {
    const { suveryInfo } = form.getFieldsValue();
    let { status, questionList } = checkCurrentPage();
    if (status) {
      if (previewType) {
        alert(formatMsg("preview.submitTips"));
      } else {
        submit();
      }
    } else {
      scrollHandler(questionList);
      form.setFieldsValue({ suveryInfo: { ...suveryInfo, questionList } });
    }
  };
  return (
    <div className="footer">
      <div className="page-control">
        {pageObj.prev && (
          <div className="btn" onClick={handlePrev}>
            {formatMsg("prevPage")}
          </div>
        )}
        {pageObj.next && (
          <div className="btn" onClick={handleNext}>
            {formatMsg("nextPage")}
          </div>
        )}
        {pageObj.submit && (
          <div className="btn" onClick={handleSubmit}>
            {posting && <div className="loading" />}
            {!posting && <span>{formatMsg("submit")}</span>}
          </div>
        )}
        <div className="page-num-bar">{`${currentPage}/${totalPage} ${formatMsg("page")}`}</div>
      </div>
      <Form.Item noStyle shouldUpdate={(prev, cur) => prev.suveryInfo !== cur.suveryInfo}>
        {({ getFieldValue }) => {
          let suveryInfo = getFieldValue("suveryInfo") || {};
          let list = suveryInfo.privacyList || [];
          if (list.length == 0) return null;
          return (
            <div className="links-bar">
              {list.map((item, i) => (
                <a href={item.url} target="_blank" rel="noreferrer" title={item.title} key={i}>
                  {item.title}
                </a>
              ))}
            </div>
          );
        }}
      </Form.Item>
    </div>
  );
};

export default Footer;
